import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { TreeModel } from '@components/tree/tree.model';
import { TreeAdapter } from '@app/shared/util/tree-adapter.utils';
import { Batch } from '@models/batch.model';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-from-batch-modal',
    templateUrl: './remove-from-batch-modal.component.html',
    styleUrls: ['./remove-from-batch-modal.component.scss']
})
export class RemoveFromBatchModalComponent implements OnChanges {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() tools: any;
    @Input() batch: Batch;
    @Input() dismissible = true;
    @Input() isLoading = false;

    @Output() cancelInfoModal = new EventEmitter<any>();
    @Output() removeFromBatch = new EventEmitter<any>();

    treeDisplayTools: TreeModel[];

    selectedTools: any[];

    newBatchSelected = false;


    constructor(private treeAdapter: TreeAdapter) {

    }

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    onCancel() {
        this.cancelInfoModal.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tools']) {
            this.treeDisplayTools = this.treeAdapter.adaptToolsToTree(this.tools, 'default');
        }
    }

    onCreateNewBatchSelected(selected = false) {
        this.newBatchSelected = selected;
    }

    get areToolsSelected() {
        return this.treeDisplayTools && this.treeDisplayTools.length > 0;
    }

    removeToolsFromBatch() {
        this.removeFromBatch.emit({tools: this.tools, batchId: this.batch ? this.batch.id : null});
    }
}
